<template>
    <div class="main" :class="[smallScreenClass]">
        <Header></Header>
        <router-view />
    </div>
</template>

<script>
import Header from 'library-components/components/Header/Header.vue';

export default {
    name: 'App',
    components: {
        Header,
    },
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
    data() {
        let smallScreenClass = ''
        if (window.innerWidth <= 820) {
            smallScreenClass = 'public-screen-between-640-820'
        }
        if (window.innerWidth <= 640) {
            smallScreenClass = 'public-screen-less-than-640'
        }
        return {
            smallScreenClass,
        };
    },
    watch: {
        $route(to) {
            document.title = to.meta.title ? `${this.$t(to.meta.title)} - ${this.$t('passport.products.public_pages')}` : this.$t('passport.products.public_pages');
        },
    },
    mounted() {
        this.headerService.title = ''
    },
};
</script>

<style lang="scss">
.main {
    height: calc(100% - 66px);
    position: relative;
    overflow: auto;
}
@media (max-width: 821px) {
    .patsnap-biz-header {
        border-bottom: none;
        box-shadow: none;
    }
    .patsnap-biz-languages {

        .patsnap-biz-header-widget__content {
            display: none !important;
        }
        .patsnap-biz-header-widget__post-icon {
            display: none !important;
        }

    }
}
</style>
